import styles from '../../pages/home_page/Template.module.scss';

export const Line2 = () => {
    return (
        <svg width="2" height="118" viewBox="0 0 2 118" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.line2}>
            <path d="M1 0V38.6056" stroke="#FF4286" stroke-width="0.637475"/>
            <path d="M1 45.6179V53.7454" stroke="#FF4286" stroke-width="0.637475"/>
            <path d="M1 60.7576V68.8851" stroke="#FF4286" stroke-width="0.637475"/>
            <path d="M1 75.8972V77.9291" stroke="#FF4286" stroke-width="0.637475"/>
            <path d="M1 84.9414V93.0689" stroke="#FF4286" stroke-width="0.637475"/>
            <path d="M1 100.081V102.113" stroke="#FF4286" stroke-width="0.637475"/>
            <path d="M1 109.125V117.253" stroke="#FF4286" stroke-width="0.637475"/>
        </svg>
    )
}